export default {
      id: "expand-usage",
      viewBox: "0 0 22 21",
      url: __webpack_public_path__ + "img/icons.svg#expand",
      toString: function () {
        return this.url;
      }
    }